import { Component, Input } from '@angular/core';

@Component({
  selector: 'arrow-back',
  templateUrl: './arrow-back.component.html',
  standalone: false,
})
export class ArrowBackComponent {
  @Input() size: number = 24;
  @Input() color: string = 'var(--icon-main-color)';
}
